import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
  selector: 'printheaderview',
  templateUrl: './printheaderview.component.html',
  styleUrls: ['./printheaderview.component.scss']
})

export class  PrintheaderviewComponent implements OnInit {
  
  @Input() hasimage: number;
  @Input() OwnerName: string;
  @Input() FormattedCode: string;
  @Input() Protocolst: string;
  @Input() ProtocolEd: string;
  @Input() Protocol: string;
  @Input() Infertility: string;
  @Input() Gender: string;
  @Input() Age: string;
  @Input() CycleNo: string;
  public Date: Date;

 
  constructor(private route: ActivatedRoute, private router: Router,) { }


  ngOnInit() {
    //alert('hasimage');
    this.Date = new Date();
  }
  

 
 
 


 
}
